export const GroupAExample = {
  total_flat_fee: 38.35,
  total_principal: 1000,
  total_outstanding_principal: 5117.7,
  total_flat_fee_accrued: 38.35,
  total: 1038.35,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      outstanding_principal: 1000,
      flat_fee_accrued: 7.5,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-03-05',
      fee: 0,
      outstanding_principal: 941.18,
      flat_fee_accrued: 7.05,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-04-05',
      fee: 0,
      outstanding_principal: 882.36,
      flat_fee_accrued: 6.61,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-05-05',
      fee: 0,
      outstanding_principal: 823.54,
      flat_fee_accrued: 6.17,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-06-05',
      fee: 0,
      outstanding_principal: 764.72,
      flat_fee_accrued: 5.73,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-07-05',
      fee: 38.35,
      outstanding_principal: 705.9,
      flat_fee_accrued: 5.29,
      principal: 705.9,
      total: 744.25,
    },
  ],
};

export const GroupAExampleFor1 = {
  total_flat_fee: 51.17,
  total_principal: 1000,
  total_outstanding_principal: 5117.7,
  total_flat_fee_accrued: 51.17,
  total: 1051.17,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      outstanding_principal: 1000,
      flat_fee_accrued: 10,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-03-05',
      fee: 0,
      outstanding_principal: 941.18,
      flat_fee_accrued: 9.41,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-04-05',
      fee: 0,
      outstanding_principal: 882.36,
      flat_fee_accrued: 8.82,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-05-05',
      fee: 0,
      outstanding_principal: 823.54,
      flat_fee_accrued: 8.23,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-06-05',
      fee: 0,
      outstanding_principal: 764.72,
      flat_fee_accrued: 7.65,
      principal: 58.82,
      total: 58.82,
    },
    {
      date: '2024-07-05',
      fee: 51.17,
      outstanding_principal: 705.9,
      flat_fee_accrued: 7.06,
      principal: 705.9,
      total: 757.07,
    },
  ],
};

export const EXAMPLE_A_DATA_12 = {
  total: 1080,
  total_flat_fee: 80,
  total_principal: 1000,
  list: [
    {
      date: '2024-01-05',
      fee: 50,
      principal: 15.88,
      total: 65.88,
    },
    {
      date: '2024-02-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-07-05',
      fee: 30,
      principal: 66.47,
      total: 96.47,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-01-05',
      fee: 0,
      principal: 447.15,
      total: 447.15,
    },
  ],
};

export const EXAMPLE_A_DATA_18 = {
  total: 1094,
  total_flat_fee: 94,
  total_principal: 1000,
  list: [
    {
      date: '2024-01-05',
      fee: 50,
      principal: 15.88,
      total: 65.88,
    },
    {
      date: '2024-02-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-07-05',
      fee: 30,
      principal: 66.47,
      total: 96.47,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-01-05',
      fee: 14,
      principal: 75.3,
      total: 89.3,
    },
    {
      date: '2023-02-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-03-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-04-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-05-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-06-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-07-05',
      fee: 0,
      principal: 136.6,
      total: 136.6,
    },
  ],
};

export const EXAMPLE_A_DATA_24 = {
  total: 1094,
  total_flat_fee: 94,
  total_principal: 1000,
  list: [
    {
      date: '2024-01-05',
      fee: 50,
      principal: 15.88,
      total: 65.88,
    },
    {
      date: '2024-02-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-07-05',
      fee: 30,
      principal: 66.47,
      total: 96.47,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-01-05',
      fee: 14,
      principal: 75.3,
      total: 89.3,
    },
    {
      date: '2023-02-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-03-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-04-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-05-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-06-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-07-05',
      fee: 0,
      principal: 85.88,
      total: 85.88,
    },
    {
      date: '2023-08-05',
      fee: 0,
      principal: 47.05,
      total: 47.05,
    },
    {
      date: '2023-09-05',
      fee: 0,
      principal: 3.67,
      total: 3.67,
    },
  ],
};

export const GroupBExample = {
  total_flat_fee: 135,
  total_principal: 1500,
  total: 1635,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-07-05',
      fee: 135,
      principal: 1500,
      total: 1635,
    },
  ],
};

export const EXAMPLE_B_DATA_12 = {
  total: 1800,
  total_flat_fee: 300,
  total_principal: 1500,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-07-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-01-05',
      fee: 300,
      principal: 1500,
      total: 1800,
    },
  ],
};

export const EXAMPLE_B_DATA_18 = {
  total: 2040,
  total_flat_fee: 540,
  total_principal: 1500,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-07-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-01-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-07-05',
      fee: 540,
      principal: 1500,
      total: 2040,
    },
  ],
};

export const EXAMPLE_B_DATA_24 = {
  total: 2370,
  total_flat_fee: 870,
  total_principal: 1500,
  list: [
    {
      date: '2024-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-07-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-08-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-09-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-10-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-11-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2024-12-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-01-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-02-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-03-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-04-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-05-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-06-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-07-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-08-05',
      fee: 0,
      principal: 0,
      total: 0,
    },
    {
      date: '2023-09-05',
      fee: 0,
      principal: 370,
      total: 370,
    },
    {
      date: '2023-10-05',
      fee: 25,
      principal: 375,
      total: 400,
    },
    {
      date: '2023-11-05',
      fee: 25,
      principal: 375,
      total: 400,
    },
    {
      date: '2023-12-05',
      fee: 20,
      principal: 380,
      total: 400,
    },
    {
      date: '2024-01-05',
      fee: 800,
      principal: 0,
      total: 800,
    },
  ],
};
